import { ref, computed } from 'vue';
import { DOCUMENT_SEARCH_URL, useDocumentSearch } from '@/features/Search';
import { useCustomToast } from '@/shared/lib';
import { HOME_SEARCH_DEFAULTS } from './home-search.types';
import type { HomeSearchCriteria, HomeSearchItemType } from './home-search.types';

const PAGE_SIZE = 6;

export function useHomeSearch() {
  const searchTerm = ref('');
  const searchCriteria = ref<HomeSearchCriteria>(HOME_SEARCH_DEFAULTS.criteria);
  const activeItemType = ref<HomeSearchItemType>(HOME_SEARCH_DEFAULTS.itemType);

  const { documents, loading, searchDocuments, clearCache } = useDocumentSearch();
  const toast = useCustomToast();

  const searchParams = computed(() => ({
    search: searchTerm.value,
    searchType: searchCriteria.value,
    sort: {},
    filter: { type: activeItemType.value },
    page: 1,
    amount: PAGE_SIZE,
    searchUrl: DOCUMENT_SEARCH_URL,
    context: 'search' as const,
  }));

  async function handleSearch(
    term: string,
    criteria: HomeSearchCriteria,
    itemType: HomeSearchItemType
  ) {
    searchTerm.value = term;
    searchCriteria.value = criteria;
    activeItemType.value = itemType;

    try {
      await searchDocuments(searchParams.value);
    } catch {
      toast.showErrorToast({
        title: 'Erro ao buscar documentos',
        message: 'Tente novamente mais tarde.',
        type: 'error',
      });
    }
  }

  function clearSearch() {
    searchTerm.value = '';
    clearCache();
  }

  return {
    documents,
    loading,
    searchTerm,
    searchCriteria,
    activeItemType,
    clearCache,
    handleSearch,
    clearSearch,
  };
}
